/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  byId: {},
};

const itemsSlice = createSlice({
  name: 'items',
  initialState,
  reducers: {
    editItem: (state, { payload: { id, field, value, ...rest } }) => {
      const { byId } = state;
      const found = byId[id];
      const updated = found ? { ...found, [field]: value, ...rest } : { [field]: value, ...rest };
      state.byId = { ...byId, [id]: updated };
    },
    setItems: (state, { payload: updated }) => {
      state.byId = { ...state.byId, ...updated };
    },
    overwriteItems: (state, { payload }) => {
      state.byId = payload;
    },
    removeItem: (state, { payload: targetId }) => {
      const { [targetId]: _, ...rest } = state.byId;
      state.byId = rest;
    },
    removeItems: (state, { payload: targetIds }) => {
      targetIds.forEach((id) => {
        delete state.byId[id];
      });
    },
  },
});

export const {
  editItem, setItems, overwriteItems, removeItem, removeItems,
} = itemsSlice.actions;

export default itemsSlice.reducer;
